import React from 'react';

const DefaultAuthContext = React.createContext(null);

export default DefaultAuthContext;
